import _ from 'lodash';

export default function mutateNote(note, mutations) {
  if (!note.allowMutations) return [note];

  const output = mutations.reduce( (newNotes, mutation ) => {
    const result = mutation(note, newNotes);
    if (typeof result === 'undefined' || result === note) return newNotes;

    newNotes.push(result);

    return newNotes;
  }, [note]);

  return output.length > 1 ? output : output[0];
}




// WEBPACK FOOTER //
// ./src/mutateNote.js